import styled from '@emotion/styled';

import { courseBannerZIndex } from '~/styles';

export const CourseInfoBannerMain = styled.section`
  position: relative;
  z-index: ${courseBannerZIndex};
  margin: auto;
  min-height: 140px;
  width: 100%;
  flex-direction: row;
  display: flex;
  padding-bottom: 60px;
`;

export const CourseInfoItem = styled.div`
  display: inline-flex;
  padding: 10px;
  flex-direction: row;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const CourseInfoHeader = styled.h3`
  color: white;
  font-size: 18px;
  margin-top: 8px;
  margin-left: 6px;
  line-height: 20pt;
`;
